// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var ConditionForm$ReactHooksTemplate = require("../surveys/ConditionForm.res.js");
var LogicCondition$ReactHooksTemplate = require("../surveys/LogicCondition.res.js");
var SurveyExclusion$ReactHooksTemplate = require("./surveyExclusion.res.js");

var initialState_selectedRule = SurveyExclusion$ReactHooksTemplate.empty();

var initialState = {
  loading: true,
  surveyExclusionRules: /* [] */0,
  formAction: "Create",
  dataFields: /* [] */0,
  showRuleModal: false,
  selectedRule: initialState_selectedRule,
  deletedConditions: /* [] */0
};

function reducer(state, action) {
  if (typeof action !== "object") {
    if (action === "FetchSurveyExclusionRulesInProgress") {
      return {
              loading: true,
              surveyExclusionRules: state.surveyExclusionRules,
              formAction: state.formAction,
              dataFields: state.dataFields,
              showRuleModal: state.showRuleModal,
              selectedRule: state.selectedRule,
              deletedConditions: state.deletedConditions
            };
    } else {
      return {
              loading: state.loading,
              surveyExclusionRules: state.surveyExclusionRules,
              formAction: state.formAction,
              dataFields: state.dataFields,
              showRuleModal: !state.showRuleModal,
              selectedRule: state.selectedRule,
              deletedConditions: state.deletedConditions
            };
    }
  }
  switch (action.TAG) {
    case "FetchSurveyExclusionRulesCompleted" :
        return {
                loading: false,
                surveyExclusionRules: action._0,
                formAction: state.formAction,
                dataFields: state.dataFields,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "FetchDataFieldsCompleted" :
        return {
                loading: state.loading,
                surveyExclusionRules: state.surveyExclusionRules,
                formAction: state.formAction,
                dataFields: action._0,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "SetFormAction" :
        return {
                loading: state.loading,
                surveyExclusionRules: state.surveyExclusionRules,
                formAction: action._0,
                dataFields: state.dataFields,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "SetSelectedRule" :
        return {
                loading: state.loading,
                surveyExclusionRules: state.surveyExclusionRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                showRuleModal: state.showRuleModal,
                selectedRule: action._0,
                deletedConditions: state.deletedConditions
              };
    case "DeleteRule" :
        var ruleToDelete = action._0;
        return {
                loading: state.loading,
                surveyExclusionRules: Belt_List.keep(state.surveyExclusionRules, (function (rule) {
                        return Caml_obj.notequal(SurveyExclusion$ReactHooksTemplate.id(rule), SurveyExclusion$ReactHooksTemplate.id(ruleToDelete));
                      })),
                formAction: state.formAction,
                dataFields: state.dataFields,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: state.deletedConditions
              };
    case "UpdateConditions" :
        var init = state.selectedRule;
        return {
                loading: state.loading,
                surveyExclusionRules: state.surveyExclusionRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                showRuleModal: state.showRuleModal,
                selectedRule: {
                  id: init.id,
                  name: init.name,
                  conditions: action._0
                },
                deletedConditions: state.deletedConditions
              };
    case "DeletedConditions" :
        return {
                loading: state.loading,
                surveyExclusionRules: state.surveyExclusionRules,
                formAction: state.formAction,
                dataFields: state.dataFields,
                showRuleModal: state.showRuleModal,
                selectedRule: state.selectedRule,
                deletedConditions: action._0
              };
    
  }
}

function SurveyExclusionRule(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchSurveyExclusionRulesInProgress");
          Js_promise.$$catch((function (error) {
                  console.log(error);
                  Curry._1(dispatch, {
                        TAG: "FetchSurveyExclusionRulesCompleted",
                        _0: /* [] */0
                      });
                  return Promise.resolve();
                }), Js_promise.then_((function (surveyExclusionRules) {
                      Curry._1(dispatch, {
                            TAG: "FetchSurveyExclusionRulesCompleted",
                            _0: surveyExclusionRules
                          });
                      return Promise.resolve();
                    }), Js_promise.then_((function (dataFields) {
                          Curry._1(dispatch, {
                                TAG: "FetchDataFieldsCompleted",
                                _0: dataFields
                              });
                          return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/survey_exclusion_rules", (function (param) {
                                        return Json_decode.field("survey_exclusion_rules", (function (param) {
                                                      return Json_decode.list((function (json) {
                                                                    return SurveyExclusion$ReactHooksTemplate.decode(dataFields, json);
                                                                  }), param);
                                                    }), param);
                                      }));
                        }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/data_fields?paginate=false", (function (param) {
                              return Json_decode.field("data_fields", (function (param) {
                                            return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                                          }), param);
                            })))));
        }), []);
  var lhsOptions = Belt_List.map(state.dataFields, (function (df) {
          return {
                  TAG: "DataField",
                  _0: df
                };
        }));
  var isFormValid = state.selectedRule.name.length > 0 && Belt_List.length(state.selectedRule.conditions) > 0;
  var rhsToString = function (condition) {
    var x = LogicCondition$ReactHooksTemplate.conditionType(condition);
    switch (x.TAG) {
      case "NumberCondition" :
          var n = x._0.rhs;
          if (n !== undefined) {
            return String(n);
          } else {
            return "";
          }
      case "StringCondition" :
          var lst = x._0.rhs;
          if (lst !== undefined) {
            return Js_array.joinWith(", ", Belt_List.toArray(lst));
          } else {
            return "";
          }
      case "ListCondition" :
          var lst$1 = x._0.rhs;
          if (lst$1 !== undefined) {
            return Js_array.joinWith(", ", Belt_List.toArray(Belt_List.map(lst$1, (function (param) {
                                  return param[1];
                                }))));
          } else {
            return "";
          }
      case "DateCondition" :
          return x._0.rhs;
      
    }
  };
  if (state.loading) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: "Loading Exclusion Rules...",
                                          className: "text-gray-600"
                                        })
                                  ],
                                  className: "flex items-center space-x-3"
                                }),
                            className: "flex items-center justify-center py-20"
                          }),
                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                    }),
                className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
              });
  }
  var tmp;
  if (state.showRuleModal) {
    var match$1 = state.formAction;
    var tmp$1;
    tmp$1 = match$1 === "Create" ? JsxRuntime.jsx("div", {
            children: "Create New Exclusion Rule"
          }) : JsxRuntime.jsx("div", {
            children: "Update Exclusion Rule"
          });
    var match$2 = state.formAction;
    var tmp$2;
    tmp$2 = match$2 === "Create" ? "Create Rule" : "Update Rule";
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          tmp$1,
                          JsxRuntime.jsx("img", {
                                className: "h-14-px float-right cursor-pointer",
                                src: Image$ReactHooksTemplate.closeIcon,
                                onClick: (function (param) {
                                    Curry._1(dispatch, "ToggleRuleModal");
                                  })
                              })
                        ],
                        className: "p-8 mb-50-px flex text-lg font-bold justify-between items-center bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border-b border-gray-200 px-6 py-6"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("label", {
                                                children: "Exclusion Rule Name",
                                                className: "w-1/4 text-sm font-medium text-gray-700 text-left"
                                              }),
                                          JsxRuntime.jsx("input", {
                                                className: "w-2/4 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150",
                                                placeholder: "Enter rule name",
                                                type: "text",
                                                value: state.selectedRule.name,
                                                onChange: (function (e) {
                                                    var init = state.selectedRule;
                                                    var updatedRule_id = init.id;
                                                    var updatedRule_name = e.target.value;
                                                    var updatedRule_conditions = init.conditions;
                                                    var updatedRule = {
                                                      id: updatedRule_id,
                                                      name: updatedRule_name,
                                                      conditions: updatedRule_conditions
                                                    };
                                                    Curry._1(dispatch, {
                                                          TAG: "SetSelectedRule",
                                                          _0: updatedRule
                                                        });
                                                  })
                                              })
                                        ],
                                        className: "flex items-center gap-2"
                                      }),
                                  SurveyExclusion$ReactHooksTemplate.name(state.selectedRule).length === 0 ? JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("p", {
                                                children: "Name can't be empty",
                                                className: "mr-44 text-red-500 text-xs mt-2"
                                              }),
                                          className: "flex justify-end w-full"
                                        }) : null
                                ],
                                className: "flex flex-col w-10/12 mb-4 pl-3.5"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("div", {
                                              children: "Exclusion Conditions",
                                              className: "text-sm font-medium text-gray-600"
                                            }),
                                        className: "flex justify-between items-center mb-3"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: $$Array.of_list(Belt_List.mapWithIndex(state.selectedRule.conditions, (function (index, condition) {
                                                    return JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx("div", {
                                                                        children: JsxRuntime.jsx(ConditionForm$ReactHooksTemplate.make, {
                                                                              lhsOptions: lhsOptions,
                                                                              condition: condition,
                                                                              updateLogicCondition: (function (updatedCondition) {
                                                                                  var init = state.selectedRule;
                                                                                  Curry._1(dispatch, {
                                                                                        TAG: "SetSelectedRule",
                                                                                        _0: {
                                                                                          id: init.id,
                                                                                          name: init.name,
                                                                                          conditions: Belt_List.mapWithIndex(state.selectedRule.conditions, (function (i, x) {
                                                                                                  if (i === index) {
                                                                                                    return updatedCondition;
                                                                                                  } else {
                                                                                                    return x;
                                                                                                  }
                                                                                                }))
                                                                                        }
                                                                                      });
                                                                                })
                                                                            }),
                                                                        className: "flex-1"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("img", {
                                                                                      className: "h-5 w-5",
                                                                                      src: Image$ReactHooksTemplate.plusCircle
                                                                                    }),
                                                                                className: "cursor-pointer",
                                                                                onClick: (function (param) {
                                                                                    var df = Belt_List.head(state.dataFields);
                                                                                    var newCondition = df !== undefined ? LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                                                                                            TAG: "DataField",
                                                                                            _0: Caml_option.valFromOption(df)
                                                                                          }) : LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                                                                                            TAG: "DataField",
                                                                                            _0: DataField$ReactHooksTemplate.empty()
                                                                                          });
                                                                                    var init = state.selectedRule;
                                                                                    Curry._1(dispatch, {
                                                                                          TAG: "SetSelectedRule",
                                                                                          _0: {
                                                                                            id: init.id,
                                                                                            name: init.name,
                                                                                            conditions: Belt_List.add(state.selectedRule.conditions, newCondition)
                                                                                          }
                                                                                        });
                                                                                  })
                                                                              }),
                                                                          JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("img", {
                                                                                      className: "h-5 w-5",
                                                                                      src: Image$ReactHooksTemplate.trashGrey
                                                                                    }),
                                                                                className: "cursor-pointer",
                                                                                onClick: (function (param) {
                                                                                    if (Belt_List.length(state.selectedRule.conditions) <= 1) {
                                                                                      return ;
                                                                                    }
                                                                                    var conditionToDelete = Belt_Option.getExn(Belt_List.get(state.selectedRule.conditions, index));
                                                                                    var updatedConditions = Belt_List.keepWithIndex(state.selectedRule.conditions, (function (param, i) {
                                                                                            return i !== index;
                                                                                          }));
                                                                                    var updatedDeletedConditions = Belt_List.add(state.deletedConditions, conditionToDelete);
                                                                                    Curry._1(dispatch, {
                                                                                          TAG: "UpdateConditions",
                                                                                          _0: updatedConditions
                                                                                        });
                                                                                    Curry._1(dispatch, {
                                                                                          TAG: "DeletedConditions",
                                                                                          _0: updatedDeletedConditions
                                                                                        });
                                                                                  })
                                                                              })
                                                                        ],
                                                                        className: "flex gap-2 items-center pt-22-px"
                                                                      })
                                                                ],
                                                                className: "flex justify-between items-start w-full gap-4"
                                                              }, String(index));
                                                  }))),
                                        className: "space-y-3"
                                      })
                                ],
                                className: "bg-gradient-to-r from-gray-50 to-blue-50 rounded-lg p-7 border border-gray-200\n                     w-11/12"
                              })
                        ],
                        className: "flex flex-col justify-between max-h-96 ml-16"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("button", {
                              children: tmp$2,
                              className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                isFormValid ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
                              ),
                              disabled: !isFormValid,
                              onClick: (function (param) {
                                  if (isFormValid) {
                                    var exclusion = state.selectedRule;
                                    var exclusionId = SurveyExclusion$ReactHooksTemplate.id(exclusion);
                                    var params = {};
                                    params["survey_exclusion_rule"] = SurveyExclusion$ReactHooksTemplate.encode(exclusion, state.deletedConditions);
                                    var match = state.formAction;
                                    var formSubmitUrl;
                                    formSubmitUrl = match === "Create" ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/survey_exclusion_rules", params) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/survey_exclusion_rules/" + String(Belt_Option.getExn(exclusionId)) + "/update", params);
                                    Js_promise.$$catch((function (error) {
                                            console.log(error);
                                            return Promise.resolve();
                                          }), Js_promise.then_((function (response) {
                                                var status = Json_decode.field("status", (function (param) {
                                                        return Json_decode.withDefault("failed", Json_decode.string, param);
                                                      }), response);
                                                if (status === "success") {
                                                  Curry._1(dispatch, "ToggleRuleModal");
                                                  Curry._1(dispatch, {
                                                        TAG: "DeletedConditions",
                                                        _0: /* [] */0
                                                      });
                                                  Js_promise.then_((function (rules) {
                                                          Curry._1(dispatch, {
                                                                TAG: "FetchSurveyExclusionRulesCompleted",
                                                                _0: rules
                                                              });
                                                          return Promise.resolve();
                                                        }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/survey_exclusion_rules", (function (param) {
                                                              return Json_decode.field("survey_exclusion_rules", (function (param) {
                                                                            return Json_decode.list((function (json) {
                                                                                          return SurveyExclusion$ReactHooksTemplate.decode(state.dataFields, json);
                                                                                        }), param);
                                                                          }), param);
                                                            })));
                                                } else {
                                                  var error = Json_decode.optional((function (param) {
                                                          return Json_decode.field("errors", (function (param) {
                                                                        return Json_decode.list(Json_decode.string, param);
                                                                      }), param);
                                                        }), response);
                                                  console.log(error);
                                                }
                                                return Promise.resolve();
                                              }), formSubmitUrl));
                                    return ;
                                  }
                                  
                                })
                            }),
                        className: "flex justify-end mt-4 p-8"
                      })
                ],
                className: "bg-white modal-data-fields z-10 shadow relative border border-gray-300 pointer-events-auto rounded-xl overflow-hidden"
              }),
          className: "w-screen z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
          style: {
            height: "calc(100vh + 5rem)"
          }
        });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("span", {
                                                      children: "🚫",
                                                      className: "text-xl"
                                                    }),
                                                className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("h1", {
                                                        children: "Exclusion Rules",
                                                        className: "text-2xl font-bold text-gray-900"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: "Configure exclusion rules to manage who can participate in the survey",
                                                        className: "text-sm text-gray-600 mt-1"
                                                      })
                                                ]
                                              })
                                        ],
                                        className: "flex items-center space-x-3"
                                      }),
                                  className: "flex items-center justify-between"
                                }),
                            className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                          }),
                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "📋",
                                                      className: "text-lg"
                                                    }),
                                                JsxRuntime.jsx("h2", {
                                                      children: "Rule List",
                                                      className: "text-lg font-bold text-gray-900"
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: String(List.length(state.surveyExclusionRules)) + " rules",
                                                      className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                    })
                                              ],
                                              className: "flex items-center space-x-2"
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "+",
                                                      className: "mr-2"
                                                    }),
                                                "Create New Rule"
                                              ],
                                              className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, {
                                                        TAG: "SetFormAction",
                                                        _0: "Create"
                                                      });
                                                  var df = Belt_List.head(state.dataFields);
                                                  var initialCondition = df !== undefined ? LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                                                          TAG: "DataField",
                                                          _0: Caml_option.valFromOption(df)
                                                        }) : LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                                                          TAG: "DataField",
                                                          _0: DataField$ReactHooksTemplate.empty()
                                                        });
                                                  var init = SurveyExclusion$ReactHooksTemplate.empty();
                                                  Curry._1(dispatch, {
                                                        TAG: "SetSelectedRule",
                                                        _0: {
                                                          id: init.id,
                                                          name: init.name,
                                                          conditions: {
                                                            hd: initialCondition,
                                                            tl: /* [] */0
                                                          }
                                                        }
                                                      });
                                                  Curry._1(dispatch, "ToggleRuleModal");
                                                })
                                            })
                                      ],
                                      className: "flex items-center justify-between"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Manage survey exclusion rules and conditions",
                                      className: "text-sm text-gray-600 mt-1"
                                    })
                              ],
                              className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                            }),
                        JsxRuntime.jsx("div", {
                              children: List.length(state.surveyExclusionRules) > 0 ? JsxRuntime.jsxs("table", {
                                      children: [
                                        JsxRuntime.jsx("thead", {
                                              children: JsxRuntime.jsxs("tr", {
                                                    children: [
                                                      JsxRuntime.jsx("th", {
                                                            children: "Name",
                                                            className: "text-left py-3 px-4 font-medium text-gray-700"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: "Conditions",
                                                            className: "text-left py-3 px-4 font-medium text-gray-700"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: "Actions",
                                                            className: "text-left py-3 px-4 font-medium text-gray-700"
                                                          })
                                                    ]
                                                  }),
                                              className: "bg-gray-50 border-b border-gray-200"
                                            }),
                                        JsxRuntime.jsx("tbody", {
                                              children: $$Array.of_list(Belt_List.map(state.surveyExclusionRules, (function (rule) {
                                                          return JsxRuntime.jsxs("tr", {
                                                                      children: [
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    children: rule.name
                                                                                  }),
                                                                              className: "px-4 py-3"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    children: $$Array.of_list(Belt_List.map(rule.conditions, (function (cond) {
                                                                                                var df = LogicCondition$ReactHooksTemplate.lhs(cond);
                                                                                                var lhs;
                                                                                                lhs = df.TAG === "Question" ? "" : DataField$ReactHooksTemplate.name(df._0);
                                                                                                var operator = LogicCondition$ReactHooksTemplate.operator(cond);
                                                                                                var rhs = rhsToString(cond);
                                                                                                return JsxRuntime.jsxs("div", {
                                                                                                            children: [
                                                                                                              JsxRuntime.jsx("span", {
                                                                                                                    children: lhs,
                                                                                                                    className: "bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-sm border border-blue-400"
                                                                                                                  }),
                                                                                                              JsxRuntime.jsx("span", {
                                                                                                                    children: operator,
                                                                                                                    className: "bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded-sm border border-gray-500"
                                                                                                                  }),
                                                                                                              rhs !== "" ? JsxRuntime.jsx("span", {
                                                                                                                      children: rhs,
                                                                                                                      className: "bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-sm border border-green-400"
                                                                                                                    }) : null
                                                                                                            ],
                                                                                                            className: "flex items-center space-x-1"
                                                                                                          });
                                                                                              }))),
                                                                                    className: "flex flex-col gap-2"
                                                                                  }),
                                                                              className: "px-4 py-3"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsxs("div", {
                                                                                    children: [
                                                                                      JsxRuntime.jsx("button", {
                                                                                            children: JsxRuntime.jsx("img", {
                                                                                                  className: "h-4 w-4",
                                                                                                  src: Image$ReactHooksTemplate.edit
                                                                                                }),
                                                                                            className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200",
                                                                                            title: "Edit rule",
                                                                                            onClick: (function (param) {
                                                                                                Curry._1(dispatch, {
                                                                                                      TAG: "SetFormAction",
                                                                                                      _0: "Update"
                                                                                                    });
                                                                                                Curry._1(dispatch, {
                                                                                                      TAG: "SetSelectedRule",
                                                                                                      _0: rule
                                                                                                    });
                                                                                                Curry._1(dispatch, "ToggleRuleModal");
                                                                                              })
                                                                                          }),
                                                                                      JsxRuntime.jsx("button", {
                                                                                            children: JsxRuntime.jsx("img", {
                                                                                                  className: "h-4 w-4",
                                                                                                  src: Image$ReactHooksTemplate.trashGrey
                                                                                                }),
                                                                                            className: "p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200",
                                                                                            title: "Delete rule",
                                                                                            onClick: (function (param) {
                                                                                                var ruleId = String(Belt_Option.getExn(SurveyExclusion$ReactHooksTemplate.id(rule)));
                                                                                                Curry._1(dispatch, {
                                                                                                      TAG: "DeleteRule",
                                                                                                      _0: rule
                                                                                                    });
                                                                                                Http$ReactHooksTemplate.fetchPostJSON("/api/v1/survey_exclusion_rules/" + ruleId + "/delete", {});
                                                                                              })
                                                                                          })
                                                                                    ],
                                                                                    className: "flex items-center space-x-2"
                                                                                  }),
                                                                              className: "py-4 px-4"
                                                                            })
                                                                      ],
                                                                      className: "border-b border-bottom-gray-600"
                                                                    }, String(Belt_Option.getWithDefault(rule.id, 0)));
                                                        })))
                                            })
                                      ],
                                      className: "w-full text-sm"
                                    }) : JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("span", {
                                                          children: "🚫",
                                                          className: "text-2xl text-gray-400"
                                                        }),
                                                    className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("h3", {
                                                            children: "No exclusion rules found",
                                                            className: "text-lg font-medium text-gray-900"
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: "Get started by creating your first exclusion rule",
                                                            className: "text-sm text-gray-500 mt-1"
                                                          })
                                                    ]
                                                  }),
                                              JsxRuntime.jsxs("button", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: "+",
                                                            className: "mr-2"
                                                          }),
                                                      "Add Your First rule"
                                                    ],
                                                    className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                    onClick: (function (param) {
                                                        Curry._1(dispatch, {
                                                              TAG: "SetFormAction",
                                                              _0: "Create"
                                                            });
                                                        var df = Belt_List.head(state.dataFields);
                                                        var initialCondition = df !== undefined ? LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                                                                TAG: "DataField",
                                                                _0: Caml_option.valFromOption(df)
                                                              }) : LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                                                                TAG: "DataField",
                                                                _0: DataField$ReactHooksTemplate.empty()
                                                              });
                                                        var init = SurveyExclusion$ReactHooksTemplate.empty();
                                                        Curry._1(dispatch, {
                                                              TAG: "SetSelectedRule",
                                                              _0: {
                                                                id: init.id,
                                                                name: init.name,
                                                                conditions: {
                                                                  hd: initialCondition,
                                                                  tl: /* [] */0
                                                                }
                                                              }
                                                            });
                                                        Curry._1(dispatch, "ToggleRuleModal");
                                                      })
                                                  })
                                            ],
                                            className: "flex flex-col items-center space-y-4"
                                          }),
                                      className: "text-center py-12"
                                    }),
                              className: "overflow-x-auto"
                            })
                      ],
                      className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                    }),
                tmp
              ],
              className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
            });
}

var make = SurveyExclusionRule;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* initialState Not a pure module */
